// webapp/supabase.js
import { createClient } from '@supabase/supabase-js'
import { captureAuthCallbackError } from './authErrors'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const authCallbackError = captureAuthCallbackError()
export const supabase = createClient(supabaseUrl, supabaseAnonKey)
